//  	移动端获取 html字体大小;
//		！！根字体不能小于12px（浏览器默认）；
//		使用less的时候  @rem:100rem;
setRem();
window.addEventListener("orientationchange", setRem);
window.addEventListener("resize", setRemresize);
function setRemresize() {
	if (window.location.pathname == '/chatPage'){
		return
	}
	setRem();
}
function setRem() {
	if (window.location.pathname.indexOf('/gathering') == 0 || window.location.pathname == '/annualAccount'){
	  return
	}
  var html = document.querySelector("html");
  var width = html.getBoundingClientRect().width;
  if (width > 650) {
      html.style.fontSize = 22 + "px";
      // $("#app").css('max-width', '650px')
      // if (window.location.hash == '#/mysteryBox'){
      //   document.getElementById('app').style.maxWidth = '440px'
      //   return
      // }else{
        document.getElementById('app').style.maxWidth = '650px'
      // }
      return
  }
	// console.log($)
  document.getElementById('app').style.maxWidth = '650px'
  // $("#app").css('max-width', '750px')
  // html.style.fontSize = 14 + "px";
  var lang = localStorage.getItem('lang') || 'zh'
  if (lang){
    if (lang != 'zh'){
      // var html = document.querySelector("html");
      html.style.fontSize = 16 + "px";
    }else{
      html.style.fontSize = width / 20 + "px";
    }
  }else{
    html.style.fontSize = width / 20 + "px";
  }
  //750px 1rem = 37.5px
  // 24px = 0.64rem
  //32px = 0.85rem
  //28px = 0.74rem
  //30px = 0.8rem
  //26px = 0.69rem
  //22px = 0.58rem
  //36px = 0.96rem
  //34px = 0.9rem
}
